import "./FullScreenPop.css";

export default function FullScreenPop(props) {

    return <div className="pop-black">
        <div id="full-screen-pop" className="pop-container">
            <div id="pop-header">
                <button onClick={(e) => { e.preventDefault(); props.closePop(); }}>X</button>
                <h5>{props.header}</h5>
            </div>
            <div id="pop-content">
                {props.component}
            </div>
        </div>
    </div>
}